import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=2d612ebb&"
import script from "./TemplateForm.vue?vue&type=script&lang=js&"
export * from "./TemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./TemplateForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports